import MorePopover from 'common/components/MorePopover'
import { CRUDAction, FeatureKey } from 'common/constants/permission'
import { useCurrentCycleInfo } from 'modules/pond/api/selector'
import { useGetCRUDByFeature } from 'modules/user/api/selector'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useRecoilValue } from 'recoil'

import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'

interface MoreActionProps {
  featureKey: FeatureKey
  onClickEdit?: (e: any) => void
  onClickDelete?: () => void
  isHideOnCompleted?: boolean
  onClickOptions?: {
    icon: ReactNode
    text: string
    action?: (e: any) => void
    crudIdx: CRUDAction
  }[]
}

const MoreAction = ({
  featureKey,
  onClickEdit,
  onClickDelete,
  onClickOptions = [],
  isHideOnCompleted = true
}: MoreActionProps) => {
  const { t } = useTranslation('pond')
  const cruds = useGetCRUDByFeature(featureKey)
  const cycleInfo = useCurrentCycleInfo()
  const isCompleted = cycleInfo?.status === 'completed'

  const defaultOptions = [
    { icon: <EditIcon />, text: t('edit'), action: onClickEdit, crudIdx: CRUDAction.Update },
    { icon: <DeleteIcon />, text: t('delete'), action: onClickDelete, crudIdx: CRUDAction.Delete },
  ]

  const options = onClickOptions.length > 0 ? onClickOptions : defaultOptions

  const getTools = () => {
    if (!cruds) {
      return []
    }

    const tools = options.filter((m) => cruds[m.crudIdx] === 1)
    return tools
  }

  if (isCompleted && isHideOnCompleted) return null

  return (
    <MorePopover hideIcon={getTools().length === 0}>
      <List>
        {getTools().map((option, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton onClick={option.action}>
              <ListItemIcon>{option.icon}</ListItemIcon>
              <ListItemText primary={option.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </MorePopover>
  )
}

export default MoreAction
